import angular from "angular";
import angularUIB from "angular-ui-bootstrap";

let mod = angular
    .module('ErrorProcessing.component', [angularUIB])
    .component('errorProcessing', {
        template: require('./error-processing.component.html'),
        controller: ['$http', 'notifier', Controller],
        bindings: { }
    });

function Controller ($http, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.baseUrl = '/control-panel/error-processing/';
        $ctrl.resetFilter();
    };


    $ctrl.resetFilter = function () {
        $ctrl.getList();
    };


    $ctrl.getList = function () {
        $http.get($ctrl.baseUrl + 'show').then(function (response) {
            $ctrl.list = response.data.model.data;
            $ctrl.total = response.data.model.total;
        });
    };


    $ctrl.remove = function (id) {
        if (confirm('Вы действительно хотите удалить запись?')){
            $http.delete($ctrl.baseUrl + id).then(function (response) {
                notifier.successNotify('Запись успешно удалена');
                $ctrl.getList();

                if ( ! $ctrl.list.length && $ctrl.currentPage > 1) {
                    $ctrl.currentPage = 1;
                    $ctrl.getList();
                }
            }, notifier.errorResponseNotify);
        }
    }
}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/error-processing/error-processing.component.js